// markup
import Button from "@material-ui/core/Button";

const TableCellCreditApplicationActions = (props) => {
  return (
    <div className="table-cell-actions">
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: "2px" }}
        onClick={() => props.putOnHold(props.item.Id)}
      >
        Put on hold
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: "2px" }}
        onClick={() => props.expire(props.item.Id)}
      >
        Expire
      </Button>
    </div>
  );
};

export default TableCellCreditApplicationActions;
